<div class="dropDownView__bg {{slide}}" [class.open]="animated$ | async" (click)="close()"></div>
<div class="dropDownView__cont {{slide}}" 
  [class.open]="animated$ | async" 
  [class.hidden]="(animatedDelay$ | async) === false"
  [class.dropDownView__cont--auto-height]="autoHeight"
  >
  <div class="dropDownView__header">
    <app-ds-header
      [widgetConfig]="headerWidgets"
      [isTransparent]="true"
      (clickAction)="headerWidgetAction($event)">
    </app-ds-header>
    <div class="dropDownView__header-divider">
      <app-ds-divider></app-ds-divider>
    </div>
  </div>
  <div class="dropDownView__content" [class.skeleton]="skeleton">
    <ng-content select="[content]"></ng-content>
  </div>
  <ng-container *ngIf="showFooter">
    <div class="dropDownView__footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </ng-container>
</div>